"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.LogoLink = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _LogoSvg = require("./LogoSvg");
var _GapOnlyLogoSvg = require("./GapOnlyLogoSvg");
const _excluded = ["href", "logoImageUrl", "isGapOnlyLogo", "isCatchLogo", "isCustomLogo", "title", "imageTitle", "imageTitleDescription", "imageTitleDescriptionMobile"];
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
const LogoLink = _ref => {
  let {
      href,
      logoImageUrl,
      isGapOnlyLogo,
      isCatchLogo,
      isCustomLogo,
      title = 'Home page',
      imageTitle = '',
      imageTitleDescription = '',
      imageTitleDescriptionMobile = ''
    } = _ref,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "logo"
  }, /*#__PURE__*/_react.default.createElement("a", {
    title: title,
    href: href,
    target: rest.target
  }, logoImageUrl && /*#__PURE__*/_react.default.createElement("img", {
    src: logoImageUrl,
    className: "logoImage",
    alt: imageTitle
  }), isGapOnlyLogo && /*#__PURE__*/_react.default.createElement(_GapOnlyLogoSvg.GapOnlyLogoSvg, null), !isGapOnlyLogo && !isCatchLogo && !isCustomLogo && !logoImageUrl && /*#__PURE__*/_react.default.createElement(_LogoSvg.LogoSvg, null), /*#__PURE__*/_react.default.createElement("span", {
    className: "sr-only"
  }, "Return to ", title), imageTitle && imageTitleDescription && /*#__PURE__*/_react.default.createElement("div", {
    className: "logo-text"
  }, /*#__PURE__*/_react.default.createElement("h3", {
    className: "logo-text-title"
  }, imageTitle), /*#__PURE__*/_react.default.createElement("span", {
    className: "logo-text-description"
  }, imageTitleDescription), /*#__PURE__*/_react.default.createElement("span", {
    className: "logo-text-description-mobile"
  }, imageTitleDescriptionMobile))));
};
exports.LogoLink = LogoLink;
LogoLink.propTypes = {
  href: _propTypes.default.string,
  logoImageUrl: _propTypes.default.string,
  isGapOnlyLogo: _propTypes.default.bool,
  isCatchLogo: _propTypes.default.bool,
  isCustomLogo: _propTypes.default.bool,
  title: _propTypes.default.string,
  imageTitle: _propTypes.default.string,
  imageTitleDescription: _propTypes.default.string,
  imageTitleDescriptionMobile: _propTypes.default.string
};
LogoLink.defaultProps = {
  href: '/'
};
var _default = exports.default = LogoLink;